import { connect } from "react-redux";
import { State } from "store";
import { project } from "store/project";
import { title } from "store/title";
import { global } from "store/global";
import { profile } from "store/profile";

const mapStateToProps = (state: State) => ({
  operatorRefs: global.selectors.operatorRefs(state),
  campaign: project.selectors.campaign(state),
  project: project.selectors.project(state),
  funderRefs: global.selectors.funderRefs(state),
  carrierRefs: global.selectors.carrierRefs(state),
  campaignActions: project.commands.campaignActions,
  currentUser: profile.selectors.User(state),
});

const mapDispatchToProps = {
  ...project.commands.campaignActions,
  setHeadBar: title.actions.setHeadBar,
  fetchCampaign: project.queries.fetchCampaign,
};

export default connect(mapStateToProps, mapDispatchToProps);
